import { FormComponentProps } from '../../types/FormComponentProps';
import AdvancedBeneficiaryNotice from './AdvancedBeneficiaryNotice/AdvancedBeneficiaryNotice';
import AssessmentAndCarePlanForFootOrthoticsShoeOnly from './AssessmentAndCarePlanForFootOrthoticsShoeOnly/AssessmentAndCarePlanForFootOrthoticsShoeOnly';
import BodyMeasurementRecord from './BodyMeasurementRecord/BodyMeasurementRecord';
import DMEPOSPaymentResponsibilityAgreementForm from './DMEPOSPaymentResponsibilityAgreementForm/DMEPOSPaymentResponsibilityAgreementForm';
import FootAssessmentFormShoeOnly from './FootAssessmentFormShoeOnly';
import FormHomeSafetyEnvironmentAssessment from './FormHomeSafetyEnvironmentAssessment/FormHomeSafetyEnvironmentAssessment';
import FormReleaseOfLiabilityItemReturn from './FormReleaseOfLiabilityItemReturn/FormReleaseOfLiabilityItemReturn';
import MedicareCappedRentalNotificationLetter from './MedicareCappedRentalNotificationLetter/MedicareCappedRentalNotificationLetter';
import MedicareDMEPOSSupplierStandardForm from './MedicareDMEPOSSupplierStandardForm/MedicareDMEPOSSupplierStandardForm';
import PatientConfirmationNoDiabetesForShoeIntakeOnly from './PatientConfirmationNoDiabetesForShoeIntakeOnly/PatientConfirmationNoDiabetesForShoeIntakeOnly';
import PatientConsentForm from './PatientConsentForm/PatientConsentForm';
import PatientOrientationForm from './PatientOrientationForm/PatientOrientationForm';

// eslint-disable-next-line react/display-name
const withPatientMode = (Component: React.FC<FormComponentProps>) => (props: FormComponentProps) =>
  <Component mode="patient" {...props} />;

const formComponents: { [key: string]: React.FC<FormComponentProps> } = {
  PatientConsentForm: withPatientMode(PatientConsentForm),
  MedicareDMEPOSSupplierStandardForm,
  PatientOrientationForm,
  DMEPOSPaymentResponsibilityAgreementForm,
  MedicareCappedRentalNotificationLetter,
  PatientConfirmationNoDiabetesForShoeIntakeOnly: withPatientMode(PatientConfirmationNoDiabetesForShoeIntakeOnly),
  FormHomeSafetyEnvironmentAssessmentDelivery: (props) => (
    <FormHomeSafetyEnvironmentAssessment {...props} variantType="delivery" />
  ),
  FormHomeSafetyEnvironmentAssessmentDropship: (props) => (
    <FormHomeSafetyEnvironmentAssessment {...props} variantType="dropship" />
  ),
  FormHomeSafetyEnvironmentAssessmentPtnPickup: (props) => (
    <FormHomeSafetyEnvironmentAssessment {...props} variantType="ptnPickup" />
  ),
  AdvancedBeneficiaryNotice: withPatientMode(AdvancedBeneficiaryNotice),
  BodyMeasurementRecord,
  FormReleaseOfLiabilityItemReturn: withPatientMode(FormReleaseOfLiabilityItemReturn),
  AssessmentAndCarePlanForFootOrthoticsShoeOnly: withPatientMode(AssessmentAndCarePlanForFootOrthoticsShoeOnly),
  FootAssessmentFormShoeOnly,
};
export default formComponents;
